import {ROUTES} from '@/utils/constants/routesConstants'
import {useOktaAuth} from '@okta/okta-react'
import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

export const Login = () => {
  const {oktaAuth, authState} = useOktaAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!authState || authState?.isAuthenticated) {
      return
    }

    oktaAuth.signInWithRedirect({originalUri: ROUTES.HOME})
  }, [authState, navigate, oktaAuth])

  return null
}
